import type { StripeSubscription } from "@arbeidsark/shared"
import styled from "styled-components"
import PeaceOfMind from "~/components/Illustrations/PeaceOfMind"
import { useTranslate } from "~/ur-react-hooks"
import { format } from "~/utils/date-fns/format"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6rem;
`

const Card = styled.div`
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  padding: 2rem;
  width: 456px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
`

const Title = styled.h3`
  margin: 0;
`

const Subtitle = styled.p`
  margin: 0;
  margin-top: 1rem;
`

const _HasPaymentMethodText = styled.p`
  text-align: center;
  margin-bottom: 0;
`

const _ButtonWrapper = styled.div`
  margin-top: 1.375rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const _Cancel = styled.button`
  ${(props) => props.theme.button.reset}
  color: ${(props) => props.theme.colors.gray60};
  margin-top: 1.375rem;

  &:hover {
    text-decoration: underline;
  }
`

const Price = styled.div`
  margin-top: 1rem;
  font-size: 1.5rem;
`

const Info = styled.p`
  text-align: center;
`

const IllustrationWrapper = styled.div`
  margin-top: 1.5rem;
`

export interface SubscriptionPersonalTrialProps {
  subscription: StripeSubscription
}

const SubscriptionPersonalTrial: React.FC<SubscriptionPersonalTrialProps> = ({
  subscription,
}) => {
  /*
    const user = useUser()
  */

  const nextPaymentFormatted = format(
    subscription.nextPayment ?? new Date(),
    "dd.MM.yyyy",
  )
  const translations = useTranslate({
    subscriptionTrialTitle: "subscription-personal.trial-title",
    subscriptionRegularTitle: "subscription-personal.regular-title",
    subscriptionTrialInfo: "subscription-personal.trial-info",
    subscriptionTrialSubtitle: [
      "subscription-personal.trial-subtitle",
      { date: nextPaymentFormatted },
    ],
    subscriptionRegularSubtitle: [
      "subscription-personal.regular-subtitle",
      { date: nextPaymentFormatted },
    ],
    subscriptionWillCancelSubtitle: [
      "subscription-personal.will-cancel-subtitle",
      { date: nextPaymentFormatted },
    ],
    subscriptionTrialButton: "subscription-personal.trial-button",
    subscriptionRegularButton: "subscription-personal.regular-button",
    subscriptionCancel: "subscription-personal.cancel",
    hasPaymentMethodText: [
      "subscription-personal.has-payment-method-text",
      { sum: "299" },
    ],
    price: ["subscription-personal.price", { price: "299" }],
    willCancel: "subscription-personal.will-cancel",
    reEnable: "subscription-personal.reactivate",
    reEnableConfirm: "subscription-personal.reactivate-confirm",
    changePeriodicity: "subscriptions.change-periodicity",
  })

  /*
    const subscriptionPeriodicity = subscription.periodicity
    const price = subscriptionPrices[subscriptionPeriodicity] / 100
    const showChangePaymentMethodButton = !user.hasActivePaymentMethod
  */

  return (
    <Layout>
      <Card>
        <Title>{translations.subscriptionTrialTitle}</Title>
        <Price>{translations.price({ price: "0" })}</Price>
        <Subtitle>{translations.subscriptionTrialSubtitle()}</Subtitle>
        <IllustrationWrapper>
          <PeaceOfMind />
          <Info>{translations.subscriptionTrialInfo}</Info>
        </IllustrationWrapper>
        {/*
        {!showChangePaymentMethodButton && (
          <HasPaymentMethodText>
            {translations.hasPaymentMethodText({ sum: price.toString() })}
          </HasPaymentMethodText>
        )}
*/}
        {/*
        <ButtonWrapper>
*/}
        {/*
          <Link to={'/subscription/trial-pay'}>
            {showChangePaymentMethodButton ? (
              <Button width="250px">
                {translations.subscriptionTrialButton}
              </Button>
            ) : (
              <OutlineButton width="250px">
                {translations.subscriptionRegularButton}
              </OutlineButton>
            )}
          </Link>
*/}
        {/*
          <Link to='/subscription/change-periodicity'>
            <OutlineButton width='250px'>
              {translations.changePeriodicity}
            </OutlineButton>
          </Link>
        </ButtonWrapper>
        <Link to='/subscription/cancel'>
          <Cancel>{translations.subscriptionCancel}</Cancel>
        </Link>
*/}
      </Card>
    </Layout>
  )
}

export default SubscriptionPersonalTrial
